import { createContext, useContext } from 'react'

import type { DialogContextValue } from './types'

/**
 * Context for sharing data between Dialog sub-components
 */
export const DialogContext = createContext<DialogContextValue | undefined>(undefined)

/**
 * Hook to access Dialog context
 */
export const useDialogContext = () => {
  const context = useContext(DialogContext)
  if (!context) {
    throw new Error('Dialog compound components must be used within Dialog')
  }
  return context
}
